import { render, staticRenderFns } from "./PageTaskColumSelectorConfigForm.vue?vue&type=template&id=3c8cf55b"
import script from "./PageTaskColumSelectorConfigForm.vue?vue&type=script&lang=js"
export * from "./PageTaskColumSelectorConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports